"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.electionSummaryViewModel = electionSummaryViewModel;
function electionSummaryViewModel(group, election) {
    return {
        groupKey: group.key,
        title: election.title,
        shortTitle: election.shortTitle,
        description: group.description ?? election.description,
        votingHours: election.votingHours ?? election.rounds?.find((round) => round.number === 1)?.votingHours ?? [],
        calculatorCount: group.calculators.length,
    };
}
